import Vue from 'vue';

import { marketingEndpointsTypes } from '@/http/endpoints/MarketingIntegrationEndpoint';


export default {
  async unsubscribeLead(lead, unit) {
    try {
      const { data } = await Vue.$http(marketingEndpointsTypes.UNSUBSCRIBE_LEAD, lead, { body: { unit, lead_uuid: lead } });
      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async getChannelsByLeadID(lead) {
    try {
      const { data } = await Vue.$http(marketingEndpointsTypes.GET_CHANNELS_BY_LEAD_ID, lead);
      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async getLeadByID(leadID) {
    try {
      const { data } = await Vue.$http(marketingEndpointsTypes.GET_LEAD_BY_ID, leadID);
      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async subscribeLeadByUnit(lead, unit) {
    try {
      const { data } = await Vue.$http(marketingEndpointsTypes.SUBSCRIBE_LEAD_BY_UNIT, lead, { body: { unit, lead_uuid: lead } });
      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  unsubscribeAllUnits(lead) {
    try {
      return this.unsubscribeLead(lead, '');
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};

